<template>
  <div class="deposit">
      <div class="deposit_1">

        <div :class="index_active==4?'active':'' " v-if="authjson.authjson(['11-1'])">
          <router-link to="/blockchain_w/transfer_p_fiat">{{$t('main.text749')}}</router-link>
        </div>
        <div :class="index_active==5?'active':'' " v-if="authjson.authjson(['11-6'])">
          <router-link to="/blockchain_w/transfer_p_jmhb">{{$t('main.text750')}}</router-link>
        </div>

      </div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index_active:1,
    }
  },
  methods: {
    set_active(){
      if(this.$route.path=='/blockchain_w/transfer_p'){
        this.index_active = 1;
      }else if(this.$route.path=='/blockchain_w/fiat_t_h'){
        this.index_active = 2;
      }else if(this.$route.path=='/blockchain_w/digital_t_h'){
        this.index_active = 3;
      }else if(this.$route.path=='/blockchain_w/transfer_p_fiat'){
        this.index_active = 4;
      }else if(this.$route.path=='/blockchain_w/transfer_p_jmhb'){
        this.index_active = 5;
      }

    },
  },
  mounted() {
    this.set_active();
  },
  watch:{
    $route(){
      this.set_active();
    }
  }
}
</script>

<style scoped>

.deposit_1{
  border-bottom: 1px solid #314B69;
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
}
.deposit_1 a{
  color: #fff;
}
.deposit_1>div{
  margin-right: 40px;
}
.active{
  font-style: normal;
  font-weight: 700;
  color: #DEB981;
  border-bottom: 3px solid #DEB981;
  padding-bottom: 4px;
}
.active a{
  color: #DEB981;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .deposit_1{
    font-size: 12px;
  }
  
}
</style>